
import React, { Component } from 'react'
import fromatTime from 'utils/formatTime'
import { Skeleton } from 'antd'
interface stateType{
    load: boolean
}
interface propsType{
    item: any
}
class LastItem extends Component<propsType, stateType> {
    constructor(props: propsType) {
        super(props)
        this.state = {
            load: false
        }

    }
    
    componentDidMount(){
    }

    loadSuccess = () => {
        this.setState({
            load: true
        })
    }
    render() {
        const {item} = this.props
        const {load} = this.state
        return (
            <dl className="last-item" key={item.id}>
                <dd>
                    <div>
                        <a href={`/news/detail/${item.id}`}><h1 title={item.name}>{item.name}</h1></a>
                        <div className="con">{item.summary}</div>
                    </div>
                    <div className="type-date">
                        <div className="type">
                            <span>{item.typeName}</span>
                            <span>{item.authors[0].username}</span>
                        </div>
                        <div className="time">{fromatTime(item.start_time * 1000)}</div>
                    </div>
                </dd>
                <dt>
                    {/* <a href={`/news/detail/${item.id}`}><Avatar photoUrl={item.cover} photoWidth={'316px'} photoHeight={'187px'} isRadius={false}></Avatar></a> */}
                    <a href={`/news/detail/${item.id}`}><img src={item.cover + '?imageView2/2/w/316/h/187'} alt="" onLoad={this.loadSuccess} id={item.id}/></a>
                    {
                        !load ? <Skeleton active className="loadingImg"/> : null
                    }
                </dt>
            </dl>
        )
    }
}
export default LastItem

